import {
    // NAVIGATION_STEP,
    BASKET_ID,
    DEALER_DETAILS,
    ADDRESS_SEARCH,
    APPOINTMENT_DETAILS,
    FROM_LINK,
    VEHICLE_INFOS,
    VEHICLE_EDIT,
    SELECTED_MILEAGE_STEP,
    OPERATIONS,
    SELECTED_FORFAITS,
    OPERATIONS_SELECTED,
    SELECTED_MANDATORY_ADDITIONAL_FORFAITS,
    // COMMENT_SERVICES,
    PERSONAL_INFOS,
    PREMIUM_SERVICES,
    SELECTED_PREMIUM_SERVICES,
    // EDITMODE,
    // DIALOG_CONFIRMATION_CHANGE_STEP,
    ATTACHMENTID,
    //ATTACHMENTURL,
    FILES,
    // DATELIMIT,
    // SELECTED_LAT,
    // SELECTED_LONG,
    // FILTER_DEALERS_BY,
    // FILTER_BY_CHOICE,
    // DEALERS_FILTRED,
    // IDRDVLEADS
}
    from './types';

export const setBasketId = basketId => ({
    type: BASKET_ID,
    basketId,
});
export const setDealerDetails = dealer => ({
    type: DEALER_DETAILS,
    dealer,
});
export const setAddressSearch = addressSearch => ({
    type: ADDRESS_SEARCH,
    addressSearch,
});
export const setAppointmentDetails = appointment => ({
    type: APPOINTMENT_DETAILS,
    appointment,
});
export const setIsFromLink = isFromLink => ({
    type: FROM_LINK,
    isFromLink,
});
export const setVeiculeInfos = vehicleInfo => ({
    type: VEHICLE_INFOS,
    vehicleInfo,
});
export const setEditVehicle = editVehicle => ({
    type: VEHICLE_EDIT,
    editVehicle,
});
export const setSelectedMileageStep = selectedMileageSteps => ({
    type: SELECTED_MILEAGE_STEP,
    selectedMileageSteps,
});
// export const setOperations = operations => ({
//     type: OPERATIONS,
//     operations,
// });
export const setSelectedForfaitsToStore = selectedForfaits => ({
    type: SELECTED_FORFAITS,
    selectedForfaits,
});
export const setSelectedMandatoryAdditionalForfaitsToStore = selectedMandatoryAdditionalForfaits => ({
    type: SELECTED_MANDATORY_ADDITIONAL_FORFAITS,
    selectedMandatoryAdditionalForfaits,
});
// export const setEditMode = isEditMode => ({
//     type: EDITMODE,
//     isEditMode,
// });
export const setSelectedOperationsToStore = (selectedOperations) => ({
    type: OPERATIONS_SELECTED,
    selectedOperations,
});
// export const setCommentServices = (commentServices) => ({
//     type: COMMENT_SERVICES,
//     commentServices,
// });
export const setPersonalInformations = (personalInfos) => ({
    type: PERSONAL_INFOS,
    personalInfos,
});
export const setSelectedPremiumServicesToStore = (selectedPremiumServices) => ({
    type: SELECTED_PREMIUM_SERVICES,
    selectedPremiumServices,
});
export const setListPremiumServices = (listPremiumServices) => ({
    type: PREMIUM_SERVICES,
    listPremiumServices,
});
// export const setDialogConfirmationStepChange = (visibaleDialogId) => ({
//     type: DIALOG_CONFIRMATION_CHANGE_STEP,
//     visibaleDialogId,
// });
export const setUploadFiles = (UploadFiles) => ({
    type: FILES,
    UploadFiles,
});
export const setCustomerAttachmentId = (customerAttachmentId) => ({
    type: ATTACHMENTID,
    customerAttachmentId,
});
// export const setCustomerAttachmentUrl = (customerAttachmentUrl) => ({
//     type: ATTACHMENTURL,
//     customerAttachmentUrl,
// });
// export const setDateLimitModif = (dateLimitModif) => ({
//     type: DATELIMIT,
//     dateLimitModif,
// });
// export const setSelectedLat = (selectedLat) => ({
//     type: SELECTED_LAT,
//     selectedLat,
// });
// export const setSelectedLong = (selectedLong) => ({
//     type: SELECTED_LONG,
//     selectedLong,
// });
// export const setFilterDealersBy = (filterDealersBy) => ({
//     type: FILTER_DEALERS_BY,
//     filterDealersBy,
// });
// export const setFilterByChoice = (filterByChoice) => ({
//     type: FILTER_BY_CHOICE,
//     filterByChoice,
// });
// export const setListDealersFiltred = (dealersFiltred) => ({
//     type: DEALERS_FILTRED,
//     dealersFiltred,
// });
// export const setIdRdvLeads = (idRdvLeads) => ({
//     type: IDRDVLEADS,
//     idRdvLeads,
// });